


/**
 * 表格头过滤
 */
const tableQuery = (state) => state.columns.filter(item => item.isQuery);

/**
 * 表格头过滤
 */
const tableHeaderFileter = (state) =>state.columns.filter(item => item.isHeader);

/**
 * 表格表单配置
 */
const formConfig = (state) => state.columns.filter(item => item.isForm);

const permissions = (state) => state.TabsPermissionData;


const permissionsTabName = (state) => state.TabsPermissionName;


const BtnPermissionData= (state) => state.BtnPermissionData;


const getKeepLiveTags=(state)=>{
  const keepLiveTagsName = state.keepLiveTags.map(item => item.name);
  return keepLiveTagsName
}



export default {
  tableQuery,
  permissions,
  BtnPermissionData,
  permissionsTabName,
  tableHeaderFileter,
  formConfig,
  getKeepLiveTags
};



// WEBPACK FOOTER //
// ./src/store/getters.js